import language from "../language";

// eslint-disable-next-line import/no-anonymous-default-export
export default (lng = "english") => [
  {
    label: language[lng].mild,
    value: "mild",
  },
  {
    label: language[lng].moderate,
    value: "moderate",
  },
  {
    label: language[lng].severe,
    value: "severe",
  },
];
